import { IS_NOT_EMPTY } from '../../utils';

export const GET_CARRIER_BUSINESS_NAME = (
	businessName: string,
	doingBusinessAs: string
): string => {
	return IS_NOT_EMPTY(doingBusinessAs) ? doingBusinessAs : businessName;
};
